export default "__VITE_ASSET__J2Tvl_Ny__"